<template>
    <button
        v-if="!active"
        type="button"
        class="screen-warning"
        :aria-label="emptyLabel"
        v-tippy="{ content: emptyLabel, theme: 'light' }"
        @click.prevent.stop
    >
        <img src="/images/warning.svg" alt="" />
    </button>
    <button
        v-else-if="details"
        type="button"
        class="screen-warning screen-warning--info"
        :aria-expanded="expanded ? 'true' : 'false'"
        aria-label="Запросы SSP за последние 7 дней"
        @click.prevent.stop="emit('toggle')"
    >
        <img src="/images/info.svg" alt="" />
    </button>
</template>

<script setup>
const emptyLabel = 'За последние 7 дней запросов SSP не было.';

defineProps({
    active: { type: Boolean, default: false },
    details: { type: Boolean, default: true },
    expanded: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);
</script>

<style lang="scss">
.screen-warning img {
    display: block;
    height: 12px;
    width: 12px;
}

.screen-warning--info {
    cursor: pointer;
}
</style>
